var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.loading)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(_vm._s(_vm.address)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }